module.exports = __webpack_public_path__ + "img/bg3.2a1ba9df.png";